/* global jQuery */

export const getCheckoutItems = () => {
  const gaViewItemElement = jQuery('[data-ga-bc]')
  if (gaViewItemElement.length === 0) {
    return null
  }

  const gaItems = gaViewItemElement.attr('data-ga-bc')
  const gaItemsParsed = JSON.parse(gaItems)

  return typeof gaItemsParsed === 'object' ? gaItemsParsed : {}
}

export const getShippingText = () => {
  const shippingElement = jQuery('select.shipping_method, input[name^="shipping_method"][type="radio"]:checked, input[name^="shipping_method"][type="hidden"]')
  const text = shippingElement
    .closest('li')
    .find('label')
    .text()
    .split(':')[0]
    .trim()

  let shippingText = text !== '' ? text : shippingElement.val()
  const currentShippingFixedDeliveryText = getShippingFixedDeliveryText()

  if (currentShippingFixedDeliveryText === undefined) {
    return shippingText
  }

  return shippingText + ' - ' + currentShippingFixedDeliveryText
}

export const getShippingFixedDeliveryText = () => {
  const shippingElement = jQuery('input[name^="shipping_method_fixed_delivery"][type="checkbox"]:checked')
  const text = shippingElement
    .closest('div')
    .find('label')
    .text()
    .split(':')[0]
    .trim()

  return text !== '' ? text : shippingElement.val()
}

export const getPaymentText = () => {
  const paymentElement = jQuery('input[name="payment_method"]:checked')
  const text = paymentElement
    .closest('li')
    .find('label')
    .text()
    .trim()

  return text !== '' ? text : paymentElement.val()
}
